import { useState, CSSProperties } from "react";
import { useSelector } from "react-redux";
import ClockLoader from "react-spinners/ClockLoader";
import { formatMessage } from '../../locale'

const override: CSSProperties = {
    display: 'flex',
    justifyContent: "center",
    alignItems: "center",
    borderWidth: "4px",
    marginBottom: "2rem"
};

function Spinner() {
  const { userCompany } = useSelector((state: any) => state.auth);
  return (
    <div className="sweet-loading" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'}}>
          <ClockLoader
              color={userCompany?.main_color}
              loading={true}
              cssOverride={override}
              size={200}
              aria-label="Loading Spinner"
              data-testid="loader"
              speedMultiplier={0.5}
          />  
          <p>{ formatMessage({id: "createEditSurvey.loading", defaultMessage: "This may take a while, please wait..." })}</p>
    </div>
  );
}

export default Spinner;